import * as Yup from "yup";

export const dnsValdidationSchema = Yup.object({
  ttl: Yup.number().typeError("Le TTL doit être un nombre !"),
  subDomain: Yup.string(),
  fieldType: Yup.string().required("Le type est requis !"),
  target: Yup.string().required("La cible est requise !"),
});
